import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { OverviewCard } from 'components/dashboard/components/overview-card';
import ReviewTable from 'components/dashboard/components/review-table';
import {
  FlexRow,
  HeaderFlexRow,
  HeadingTitle,
  Container,
  PlainButton,
} from 'components/styled-components';
import {
  StatContainer,
  BlueSection,
  DashboardContent,
  H2Dashboard,
} from 'components/dashboard/components/styled-components';
import * as actions from 'actions/vendor-request';
import colors from 'utils/colors';
import { getDashboardHeaders, getDashboardFields } from 'utils/functions';

import constants from 'utils/constants';
const { DEPARTMENT_REVIEW_STATES } = constants;

const splitReviewStatus = (requests, deptID) => {
	let needsReview = [];
	let hasReview = [];
	if(requests.totalCount > 0){
		requests.result.forEach(request => {
			let myReview = request.DepartmentalReviews.find(dr => dr.DepartmentID == deptID);
			if(typeof myReview !== 'undefined'){
				if(myReview.Response === null){
					needsReview.push(request);
				}else{
					hasReview.push(request)
				}
			}
		})
	}
	return {
		needsReview: { totalCount: needsReview.length, result: needsReview },
		hasReview: { totalCount: hasReview.length, result: hasReview }
	};
}

const DashboardOverview = ({ needsReview, hasReview, onlyMine, appUser }) => (
  <StatContainer>
    <OverviewCard
      title="Assessments Needing Review"
      icon="time"
      color={colors.icons.azure}
      data={needsReview}
      filterType="DepartmentReviewStatus"
      filter={'Not Reviewed'}
    />
    <OverviewCard
      title="Assessments Reviewed by Department"
      icon="updated"
      color={colors.icons.amber}
      data={hasReview}
      filterType="DepartmentReviewStatus"
      filter={'Reviewed'}
    />
    <OverviewCard
      title="My ongoing assessments"
      icon="time"
      color={colors.icons.amber}
      data={onlyMine}
			filterType="sponsorID"
			displayFilter={`Sponsor > ${appUser.firstName} ${appUser.lastName}`}
			filter={appUser.userID}
    />
  </StatContainer>
);

class DashboardDepartmentReviewer extends Component {
  componentDidMount() {
    this.props.fetchAllVendorRequests({ start: 0, limit: -1 });
  }

  render() {
    const { areReviewable, appUser, onlyMine } = this.props;
	const { needsReview, hasReview } = splitReviewStatus(areReviewable, appUser.departmentID);
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Dashboard</HeadingTitle>
		  <NavLink to="/new">
            <PlainButton>Create Assessment</PlainButton>
          </NavLink>
        </HeaderFlexRow>
        <BlueSection>
          <H2Dashboard>Assessments Overview</H2Dashboard>
          <DashboardOverview
            needsReview={needsReview['totalCount']}
            hasReview={hasReview['totalCount']}
						onlyMine={onlyMine['totalCount']}
						appUser={appUser}
          />
          <H2Dashboard>Recent Assessments</H2Dashboard>
        </BlueSection>

        <DashboardContent>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="Assessments Needing Review"
              data={needsReview}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="time"
              color={colors.icons.azure}
              flexBasis="100%"
              filterType="DepartmentReviewStatus"
			  			filterAltName="Department Review Status"
              filter={'Not Reviewed'}
              appUser={appUser}
            />
            <ReviewTable
              title="Assessments Reviewed by Department"
              data={hasReview}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="updated"
              color={colors.icons.amber}
              flexBasis="100%"
              filterType="DepartmentReviewStatus"
			  			filterAltName="Department Review Status"
              filter={'Reviewed'}
              appUser={appUser}
            />
            <ReviewTable
              title="My ongoing assessments"
              data={onlyMine}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="time"
              color={colors.icons.amber}
              flexBasis="100%"
              filterType="sponsorID"
			  			filterAltName="Sponsor"
							displayFilter={`Sponsor > ${appUser.firstName} ${appUser.lastName}`}
      				filter={appUser.userID}
              appUser={appUser}
            />
          </FlexRow>
        </DashboardContent>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  areReviewable: state.vendorRequest.allRequestsReviewable,
  onlyMine: state.vendorRequest.onlyMyRequests,
});

DashboardDepartmentReviewer = connect(
  mapStateToProps,
  actions
)(DashboardDepartmentReviewer);

export default DashboardDepartmentReviewer;
